import { ROUTES } from "@/config/routes";

const defaultDescription =
  "Swargaseema offers verified open plot projects near Shadnagar and South Hyderabad with documentation-first support.";

const defaultImage = "/assets/brand/swargaseema-logo-official.png";

export const siteUrl = (process.env.NEXT_PUBLIC_SITE_URL || "https://www.swargaseema.com").replace(/\/$/, "");

function cleanPath(path = ROUTES.HOME) {
  const [pathname] = path.split(/[?#]/);
  return pathname || ROUTES.HOME;
}

export function absoluteUrl(value = ROUTES.HOME) {
  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  const normalizedPath = value.startsWith("/") ? value : `/${value}`;
  return `${siteUrl}${normalizedPath}`;
}

export function getPageSeo({
  title = "Swargaseema",
  description = defaultDescription,
  image = defaultImage,
  path = ROUTES.HOME,
  type = "website",
  noIndex = false
} = {}) {
  const canonicalPath = cleanPath(path);
  const canonical = absoluteUrl(canonicalPath);
  const imageUrl = absoluteUrl(image);

  return {
    title,
    description,
    canonical,
    image: imageUrl,
    robots: noIndex ? "noindex,nofollow" : "index,follow",
    openGraph: {
      title,
      description,
      image: imageUrl,
      type,
      url: canonical
    },
    twitter: {
      card: "summary_large_image",
      title,
      description,
      image: imageUrl
    }
  };
}

export function getOrganizationJsonLd(site: any) {
  return {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    name: site.name,
    url: siteUrl,
    logo: absoluteUrl(defaultImage),
    image: absoluteUrl(defaultImage),
    telephone: site.phone,
    email: site.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: site.address,
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500032",
      addressCountry: "IN"
    },
    areaServed: ["Shadnagar", "South Hyderabad", "Telangana"]
  };
}

export function getWebsiteJsonLd(site: any) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: site.name,
    url: siteUrl,
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteUrl}${ROUTES.PROJECTS}?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };
}

export function getProjectJsonLd(project: any) {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: project.name,
    description: project.summary,
    image: absoluteUrl(project.hero),
    brand: {
      "@type": "Brand",
      name: "Swargaseema"
    },
    category: "Open plots",
    url: absoluteUrl(ROUTES.PROJECT(project.slug)),
    areaServed: project.location,
    additionalProperty: [
      { "@type": "PropertyValue", name: "Approval", value: project.approval },
      { "@type": "PropertyValue", name: "Extent", value: project.acreage },
      { "@type": "PropertyValue", name: "Location", value: project.location },
      { "@type": "PropertyValue", name: "Status", value: project.status }
    ].filter((item) => item.value)
  };
}
